// config.js

const bizIcon = "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg";
const imageOne = "https://static.wixstatic.com/media/13eefd27e5a543a688fff990b0adb35b.jpg/v1/fill/w_1253,h_678,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/13eefd27e5a543a688fff990b0adb35b.jpg";
const imageTwo = "https://static.wixstatic.com/media/74f558_993f041afc4045c69c824d6022d78ca0~mv2_d_4000_2667_s_4_2.jpeg/v1/fill/w_344,h_726,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_auto/74f558_993f041afc4045c69c824d6022d78ca0~mv2_d_4000_2667_s_4_2.jpeg";
const imageThree = "https://static.wixstatic.com/media/74f558_4ef3f401e4a2400a8979c42d1a7ba1a7~mv2_d_5760_3840_s_4_2.jpeg/v1/fill/w_340,h_726,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_auto/74f558_4ef3f401e4a2400a8979c42d1a7ba1a7~mv2_d_5760_3840_s_4_2.jpeg";
const imageFour = "https://static.wixstatic.com/media/74f558_9b1cc2c7424d47bf83b890c15ed8127f~mv2_d_5625_3750_s_4_2.jpg/v1/fill/w_340,h_726,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_auto/74f558_9b1cc2c7424d47bf83b890c15ed8127f~mv2_d_5625_3750_s_4_2.jpg";
const imageFive = "https://newcity.co/wp-content/uploads/2021/07/Website-Images_Painting.jpg";

const socialMediaLink = 'https://www.bargainpropainting.com/';

export const siteConfig = {
  title: "Bargain Professional Painting LLC",
  metaDescription: "Bargain Professional Painting LLC",
  theme: {
    primaryColor: "orange-500",
    secondaryColor: "gray-200",
    accentColor: "text-orange-500"
  },
  logo: {
    src: bizIcon,
    alt: "Bargain Professional Painting",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Bargain Professional Painting",
    headling: "Quality You Can See, Service That You Can Trust",
    address: "411 S 13th Street, Chesterton, Indiana 46304",
    description: "Let us bring your vision to life with vibrant colors and flawless finishes!"
  }, 
  images: {
    business: {
      src: imageOne,
      alt: "Bargain Professional Painting",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description:
        "Experience unmatched attention to detail, ensuring every project leaves a lasting, quality impression."
    },
    {
      description:
        "Enjoy a personalized service crafted to bring your unique vision to life, tailored precisely to your needs."
    },
    {
      description:
        "Rely on us as your trusted partner for premium results in painting, staining, restoration, and construction services."
    }
  ],
  services: {
    sectionTitle: "Our Services",
    description: "With over a decade in the painting industry, we are dedicated to delivering exceptional quality and service. Our skilled professionals enhance the beauty of both residential and commercial spaces, creating finishes that last",
    callouts: [
      {
        name: 'Residential Painting Services',
        description: 'Enhancing home interiors and exteriors with quality painting finishes.',
        imageSrc: imageTwo,
        imageAlt: 'Modern interior with fresh paint'
      },
      {
        name: 'Commercial Painting Services',
        description: 'Professional painting for businesses, enhancing brand image and appeal.',
        imageSrc: imageThree,
        imageAlt: 'Stylish painted kitchen cabinets'
      },
      {
        name: 'Interior Painting Services',
        description: 'Transforming indoor spaces with fresh colors and stylish finishes.',
        imageSrc: imageFour,
        imageAlt: 'Driveway being pressure washed'
      }
  ],  
    otherServices: [
      "Exterior Painting Services",
    ]
  },  
  about: {
    sectionTitle: "About Us",
    description: "We offer a comprehensive range of painting services, including interior and exterior painting, custom finishes, and expert color consultations. By using premium materials and the latest techniques, we ensure every project meets the highest standards.",
    image: {
      src: imageFive,
      alt: "Bargain Professional Painting LLC",
      width: 2432,
      height: 1442
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "411 S 13th Street, Chesterton, Indiana 46304, USA",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2958.123456789123!2d-87.0654!3d41.6103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x881206789abcdef%3A0xabcdef1234567890!2s411%20S%2013th%20St%2C%20Chesterton%2C%20IN%2046304%2C%20USA!5e0!3m2!1sen!2sph!4v1710407450828!5m2!1sen!2sph",
    subCategories: [
      { name: 'Apple Maps', url: 'https://maps.apple.com/?address=411%20S%2013th%20St,%20Chesterton,%20IN%2046304&ll=41.6103,-87.0654&q=411%20S%2013th%20St,%20Chesterton,%20IN%2046304' },
      { name: 'Bing Maps', url: 'https://www.bing.com/maps?q=411+S+13th+St,+Chesterton,+IN+46304&form=HDRSC6&sp=1&pq=411+s+13th+st+chesterton+in+46304&sc=0-0&qs=n&sk=&cvid=EDFC0FE5A0E74E8DB130342A842AA10C' },
      { name: 'Google Earth', url: 'https://earth.google.com/web/search/411+S+13th+St,+Chesterton,+IN+46304,+USA/@41.6103,-87.0654,15.26523397a,814.57589625d,35y,0h,0t,0r' },
      { name: 'Google Maps', url: 'https://maps.app.goo.gl/4Y2YfHGWxgrC8tTE7' }
    ]
  },
  contact: {
    sectionTitle: "Get Your Free Estimate Now!",
    description: "Ready to transform your space with Bargain Professional Painting LLC? Contact us today to discuss your project and experience the exceptional service and craftsmanship that sets us apart. We're here to bring your vision to life.",
    socialLinks: {
      facebook: socialMediaLink,
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      youtube: socialMediaLink,
      tiktok: socialMediaLink
    },
    contactNumbers: ["219-973-1640"],
    logo: bizIcon,
    emailRecipient: "bargainpropainting@outlook.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
